import React from 'react'
import "./login.css"
import { Link } from 'react-router-dom'
const Register = () => {
  return (
    <div className='content'>
      <div className='auth'>
        <h1>Register</h1>
        <form>
          <input required type='text' placeholder='username'/>
          <input required type='email' placeholder='email'/>
          <input required type='password' placeholder='password'/>
          <button className='btnLogin'>Register</button>
          <p>Error Message!!!!</p>
          <span>Do you have an account ? <Link to="/login">Login</Link>
          </span>
        </form>
      </div>
    </div>
  )
}

export default Register
